import { ColorNames, Theme } from '@/utils/constants';
import clsx from 'clsx';
import React, { memo, PropsWithChildren, useEffect, useState } from 'react';
import { MuiContainer } from '@/features/shared/material-ui';
import { HomepageContentProps } from './HomepageContent.interface';
import useStyles from './HomepageContent.styles';
import { Overlay } from './Overlay';
import { Timed } from './Timed';

const HomepageContent = ({
  animatedHeading,
  subheading,
  overflowContent = false,
  overlayColor = ColorNames.charcoal,
  theme = Theme.light,
  contentButtons,
}: PropsWithChildren<Br.PropsWithContentButtons<HomepageContentProps>>) => {
  const classes = useStyles({ theme });
  const { segments = [], staticHeadline } = animatedHeading || {};
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const shouldLockHeader = window.scrollY < window.screen.height;
      const nextIndex = window.scrollY > 1 ? segments.length - 1 : 0;

      if (nextIndex !== index) {
        setIndex(nextIndex);
      }

      document.dispatchEvent(new Event(shouldLockHeader ? 'lockheader' : 'unlockheader'));
      setIndex(nextIndex);
    };

    document.addEventListener('scroll', handleScroll, { passive: true });

    return () => document.removeEventListener('scroll', handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.dispatchEvent(new Event('lockheader'));
  }, []);

  const parallaxProps = {
    segments,
    staticHeadline,
    subheading,
    animateFromTop: true,
  };

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <MuiContainer
          className={classes.muiContainer}
          maxWidth={overflowContent ? undefined : false}
          disableGutters={!overflowContent}
        >
          <div className={classes.elementsContainer}>
            <Timed
              index={index}
              overflowContent={overflowContent}
              className={classes.elements}
              theme={theme}
              {...parallaxProps}
            >
              {contentButtons?.content}
            </Timed>
          </div>
        </MuiContainer>
      </div>
      <div className={clsx(classes.overlay)}>
        <Overlay bgColor={overlayColor} height="100%" start={0.5} end={0.85} />
      </div>
      {/* <div className={classes.interactiveArea} /> */}
    </div>
  );
};

export default memo(HomepageContent);
